import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {
    COLOR_PRIMARY_DARK,
    COLOR_PRIMARY_LIGHT,
    COLOR_INFO_LIGHT,
    COLOR_SPACE_GRAY,
    COLOR_ERROR_TEXT,
    COLOR_SHALLOW_TEXT,
    COLOR_SHALLOW_GRAY,
    COLOR_SUCCESS,
    COLOR_WARNING,
    COLOR_LIGHT_RED
} from '@/config/consts';

import i18n from '../i18n';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: COLOR_PRIMARY_LIGHT,
                info: COLOR_INFO_LIGHT,
                gray: COLOR_SPACE_GRAY,
                'error-text': COLOR_ERROR_TEXT,
                primaryDark: COLOR_PRIMARY_DARK,
                shallow: COLOR_SHALLOW_TEXT,
                shallowGray: COLOR_SHALLOW_GRAY,
                success: COLOR_SUCCESS,
                warning: COLOR_WARNING,
                lightRed: COLOR_LIGHT_RED
            },
            dark: {
                primary: COLOR_PRIMARY_DARK
            }
        }
    }
});
